<template>
	<div
		class="event-card"
		:style="backgroundStyle"
	>
		<div v-if="event.event_date" class="event_date d-flex d-lg-none align-items-center">
			{{ event.event_date | moment("DD MMMM YYYY") }}
			<a
				v-b-tooltip.hover.top="$t('AddCal')"
				:href="'//sk.skolkovo.ru/api/calendar/event/' + event.id"
				class="add_announce ml-2"
				aria-label="$t('AddCal')"
			/>
		</div>
		<div class="event-card__footer">
			<div class="event-card__title">
				<span
					v-if="block.show_alumni_link && !isAlumni"
					class="title"
				>
					{{ event.title }}
				</span>

				<nuxt-link
					v-else
					:to="$url.event(event.slug, event.typology_slug)"
					class="title"
				>
					{{ event.title }}
				</nuxt-link>
			</div>
			<div class="event-card__info">
				<ArrowButton :url="$url.event(event.slug, event.typology_slug)" size="md">
					Подробнее
				</ArrowButton>
				<!-- <GlowButton :url="$url.event(event.slug, event.typology_slug)">
					Подробнее
				</GlowButton> -->
				<div v-if="event.event_date" class="event_date d-none d-lg-flex align-items-center">
					{{ event.event_date | moment("DD MMMM YYYY") }}
					<a
						v-b-tooltip.hover.top="$t('AddCal')"
						:href="'//sk.skolkovo.ru/api/calendar/event/' + event.id"
						class="add_announce ml-2"
						aria-label="$t('AddCal')"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import GlowButton from '~/components/buttons/GlowButton.vue';
import ArrowButton from '~/components/buttons/ArrowButton.vue';

export default {
	name: 'EventCard',
	components: { GlowButton, ArrowButton },
	props: {
		event: {
			type: Object,
			default: () => {},
		},
		block: {
			type: Object,
			default: () => {},
		},
		isAlumni: {
			type: Boolean,
			default: false,
		},
		image: {
			type: String,
			default: '',
		},
	},
	computed: {
		backgroundStyle() {
			return {
				'background-image': `url('${this.image}')`,
				backgroundSize: 'cover',
				backgroundPosition: 'center',
			};
		},
	},
};
</script>

<style scoped lang="scss">
@import "assets/styles/sk_variables";
// For use bootstrap vars and mixins inside
@import "assets/styles/bootstrap/scss/functions";
@import "assets/styles/bootstrap/scss/variables";
@import "assets/styles/bootstrap/scss/mixins";

@mixin ellipsis($line: 1) {
	display: -webkit-box; /* Используется для создания контейнера flexbox */
	-webkit-line-clamp: $line;
	-webkit-box-orient: vertical; /* Устанавливает вертикальную ориентацию */
	overflow: hidden; /* Скрывает текст, выходящий за пределы */
	text-overflow: ellipsis; /* Добавляет многоточие */
}

.event-card {
	aspect-ratio: 16/9;
	flex: 1;
	margin-bottom: 1.5rem;
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: .6rem;
	border-radius: 1rem;
	background-position: center;
	background-repeat: no-repeat;
	background-size: cover;
	color: $white;
	overflow: hidden;
	padding: 1rem 0.75rem;
	z-index: 0;

	@include overlay_shadow;

	@include media-breakpoint-up(md) {
		justify-content: flex-end;
	}

	@include media-breakpoint-up(sm) {
		padding: 1rem 1rem;
	}

	&::before {
		z-index: -1;
	}

	.event_date  {
		line-height: 1;
		font-size: 0.7rem;
		@include media-breakpoint-up(lg) {
			font-size: 1rem;
		}
	}

	&__title {
		margin-bottom: 1rem;
		.title {
			line-height: 1.3;
			color: $white;
			@include ellipsis(2);

			@include media-breakpoint-only(md) {
				font-size: 1.2rem;
			}

			@include media-breakpoint-only(xs) {
				font-size: 1rem;
			}

		}
	}

	&__info {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.add_announce {
		position: relative;
		letter-spacing: 0;
		text-decoration: none;
		color: $white;

		&:hover {
			opacity: 0.8;
		}

		&::before {
			content: "\e921";
			display: block;
			font-family: 'sk_icons';
			line-height: 1rem;
			font-size: 0.7rem;
			@include media-breakpoint-up(lg) {
				font-size: 1rem;
			}
		}
	}
}
</style>
